import type { DecryptionStrategy } from 'features/e2ee/core/decryption-strategies';
import { store } from 'store/store';
import { whiteboardKeyDecrypted } from 'features/e2ee/actions';
import { base64Decrypt } from 'features/e2ee/utils/base64Decrypt';
import type { E2eeReceiver } from 'features/e2ee/E2eeReceiver';
import type { E2EEWhiteboardManager } from 'features/e2ee/E2EEWhiteboardManager';
import type { EncryptedData } from 'features/e2ee/types';

export class WhiteboardDecryption implements DecryptionStrategy {
  constructor(private whiteboard: E2EEWhiteboardManager) {}

  canHandle(data: EncryptedData) {
    return !!data.whiteboard;
  }

  async decrypt(data: EncryptedData, receiver: E2eeReceiver): Promise<void> {
    if (!receiver.sharedSecret) {
      throw new Error('Cannot decrypt whiteboard key. Shared secret is not defined');
    }

    const { id, key } = data.whiteboard!;

    const whiteboardKey = await base64Decrypt(key, receiver.sharedSecret);
    await this.whiteboard.importKey(whiteboardKey, id, receiver.roomId);

    store.dispatch(
      whiteboardKeyDecrypted({
        id,
        roomId: receiver.roomId,
      })
    );
  }
}
